import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '仪表盘', icon: 'el-icon-s-data' }
      },
      {
        path: 'user/list',
        name: 'UserList',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '用户列表' }
      },
      {
        path: 'user/feedback',
        name: 'UserFeedback',
        component: () => import('@/views/user/feedback.vue'),
        meta: { title: '用户反馈' }
      },
      {
        path: 'pet-sitter/list',
        name: 'PetSitterList',
        component: () => import('@/views/pet-sitter/index.vue'),
        meta: { title: '宠托师列表' }
      },
      {
        path: 'pet-sitter/audit',
        name: 'PetSitterAudit',
        component: () => import('@/views/pet-sitter/audit.vue'),
        meta: { title: '宠托师审核' }
      },
      {
        path: 'order/list',
        name: 'OrderList',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '订单列表' }
      },
      {
        path: 'finance/transaction',
        name: 'TransactionList',
        component: () => import('@/views/finance/transaction.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'finance/refund',
        name: 'RefundList',
        component: () => import('@/views/finance/refund.vue'),
        meta: { title: '退款管理' }
      },
      {
        path: 'finance/withdrawal',
        name: 'WithdrawalList',
        component: () => import('@/views/finance/withdrawal.vue'),
        meta: { title: '提现管理' }
      },
      {
        path: 'system/menu',
        name: 'MenuManagement',
        component: () => import('@/views/system/menu.vue'),
        meta: { title: '菜单管理' }
      },
      {
        path: 'system/role',
        name: 'RoleManagement',
        component: () => import('@/views/system/role.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'system/log',
        name: 'OperationLog',
        component: () => import('@/views/system/log.vue'),
        meta: { title: '操作日志' }
      },
      {
        path: 'system/config',
        name: 'SystemConfig',
        component: () => import('@/views/system/config.vue'),
        meta: { title: '系统配置' }
      }
    ]
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '页面不存在' }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
    return
  }
  
  if (to.path === '/404') {
    next()
    return
  }
  
  if (!token) {
    next('/login')
    return
  }
  
  next()
})

export default router
